import React, { useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Card,
  CardContent,
  Typography,
  Button,
  Container,
} from "@material-ui/core";
import { Link } from "react-router-dom";

const PreviousYearPapersMobile = ({ previousyearpaperDetail }) => {
  return (
    <Container maxWidth="sm">
      {previousyearpaperDetail.pdf_papers && (
        <>
          <Box sx={{ bgcolor: "#FFF6E1", borderRadius: "8px", mb: 2 }}>
            <Tabs
              variant="fullWidth"
              textColor="primary"
              indicatorColor="primary"
            >
              <Tab label="Previous Year Papers" />
            </Tabs>
          </Box>
            <Box>
              {previousyearpaperDetail.pdf_papers.map((card) => (
                <Card key={card.id} sx={{ mb: 2, boxShadow: 1 }}>
                  <CardContent
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography fontWeight="bold">
                      {card.previous_year_paper_name} 
                    </Typography>
                    <Link 
                    to={card.pdf_url}
                    target={"_blank"}
                    >
                    <Button
                      variant="contained"
                      style={{
                        marginTop: "10px",
                        background:
                          "linear-gradient(90deg, #141E30 0%, #243B55 100%)",
                        color: "white",
                      }}
                    >
                      Download
                    </Button>
                        </Link>
                  </CardContent>
                </Card>
              ))}
            </Box>
        </>
      )}
    </Container>
  );
};

export default PreviousYearPapersMobile;
